<template>
  <div class="product-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>油站报价</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="section-header">
          <i class="el-icon-search"></i>
          <span>筛选查询</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="100px"
                    autocomplete="on"
                    size="small"
                    class="search-form"
            >

              <el-form-item label="所属省市" prop="province_id">
                <el-cascader
                        ref="cascaderAddr"
                        style="width: 90%"
                        v-model="areaList"
                        clearable
                        filterable
                        :props="propsdata"
                        :key="isResouceone"
                        @change="handleChangeAddress"
                        placeholder="请选择省市"

                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="油站关键字">
                <el-input
                        v-model="searchForm.keyword"
                        placeholder="油站名称/电话/地址"
                        clearable
                        type="text"
                        suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
              <el-form-item label="产品名称">
                <el-input
                        v-model="searchForm.name"
                        clearable
                        type="text"
                        placeholder="请输入产品名称"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="4" class="search-btns">
            <el-button size="small" type="primary" @click="searchSubmit()" icon="el-icon-search">搜索</el-button>
            <el-button size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <div class="section-header">
          <i class="el-icon-tickets"></i>
          <span>数据列表</span>
          <div class="table-actions">
            <el-button size="small" type="text" icon="el-icon-download">导出</el-button>
          </div>
        </div>

        <el-table
                ref="multipleTable"
                :data="tableLoadData"

                stripe
                border
                size="small"
                class="data-table"
                :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column
                  label="产品名称"
                  width="120"
                  prop="name"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="区域"
                  width="160"
                  prop="name"
                  :show-overflow-tooltip='true'
          >
            <template slot-scope="scope">
              <span>
                {{scope.row.shop!=null?scope.row.shop.province.region_name:""}}{{scope.row.shop!=null?scope.row.shop.city.region_name:""}}{{scope.row.shop!=null?scope.row.shop.district.region_name:""}}
              </span>
            </template>
          </el-table-column>

          <el-table-column
                  label="所属商户"
                  width="200"
                  prop="name"
                  :show-overflow-tooltip='true'
          >
            <template slot-scope="scope">
              <span>
                {{scope.row.shop!=null?scope.row.shop.name:""}}
              </span>
            </template>
          </el-table-column>

          <el-table-column
                  label="金额"
                  width="90"
                  :show-overflow-tooltip='true'
                  align="right"
          >
            <template slot-scope="scope">
              <span class="price">{{ scope.row.actual_price }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="查看次数"
                  :show-overflow-tooltip='true'
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag size="mini" type="info">{{ scope.row.look_num }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
                  label="发布次数"
                  :show-overflow-tooltip='true'
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag size="mini" type="warning">{{ scope.row.add_num }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
                  label="月数"
                  :show-overflow-tooltip='true'
                  align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.month_num }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  fixed="right"
                  label="操作"
                  width="100"
                  align="center"
          >
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="goInfo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px" class="custom-dialog">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from "axios";     //日期时间转换

  export default {
    name: "productList",
    components: {
    },
    props: {},
    data() {
      return {
        areaList:[],
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          checkStrictly: true,
          lazy: true,
          lazyLoad(node, resolve) {
            // const { level } = node;
            console.log(node)
            let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                //  var _this=this;

                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:1
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                       // leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
            }, 100);
          },
        },
        // 搜索
        searchForm: {
          name: "",
          shop_id:'',
          keyword:'',
          province_id:'',
          city_id:'',
          district_id:''
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入保司名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },


    },
    methods: {
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        console.log('checkedNode',checkedNode[0].path)
        if(checkedNode[0].path.length==1){
          _this.searchForm.province_id=checkedNode[0].path[0];
        }
        if(checkedNode[0].path.length==2){
          _this.searchForm.province_id=checkedNode[0].path[0];
          _this.searchForm.city_id=checkedNode[0].path[1];
        }
        if(checkedNode[0].path.length==3){
          _this.searchForm.province_id=checkedNode[0].path[0];
          _this.searchForm.city_id=checkedNode[0].path[1];
          _this.searchForm.district_id=checkedNode[0].path[2];
        }


      },
      // 重置搜索
      resetSearch() {
        this.searchForm = {
          name: "",
          shop_id:'',
          keyword:''
        };
        this.areaList = [];
        this.DataList();
      },

      goEdit(row){
        console.log(row)
        // this.$router.push({
        //   path:'/hisProductForm',
        //   query:{
        //     id:row.id
        //   }
        // })
      },
      goCategory(){
        this.$router.push('/hisProductCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(!isNaN(this.searchForm.shop_id)){
          param.shop_id=this.searchForm.shop_id;
        }
        if(!isNaN(this.searchForm.province_id)){
          param.province_id=this.searchForm.province_id;
        }
        if(!isNaN(this.searchForm.city_id)){
          param.city_id=this.searchForm.city_id;
        }
        if(!isNaN(this.searchForm.district_id)){
          param.district_id=this.searchForm.district_id;
        }
        if(this.searchForm.name){
          param.queryparam=this.searchForm.name;
        }

        if(this.searchForm.keyword){
          param.keyword=this.searchForm.keyword;
        }
        this.$axios.findProdcutListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/goodsForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.pageNum=1;
        this.tableLoadData=[];
        this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>

<style scoped>
  .product-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 60px);
  }

  .breadcrumb-container {
    margin-bottom: 20px;
  }

  .main-card {
    border-radius: 8px;
    border: none;
  }

  .section-header {
    display: flex;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
    color: #409eff;
    font-weight: 600;
  }

  .section-header i {
    margin-right: 8px;
    font-size: 16px;
  }

  .table-actions {
    margin-left: auto;
  }

  .search-section {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f9fafc;
    border-radius: 6px;
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
  }

  .search-btns {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding-top: 32px;
  }

  .table-section {
    margin-top: 20px;
  }

  .data-table {
    border-radius: 6px;
    overflow: hidden;
  }

  .price {
    color: #f56c6c;
    font-weight: 600;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .custom-dialog .el-dialog__header {
    background-color: #f5f7fa;
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;
  }

  .custom-dialog .el-dialog__title {
    color: #303133;
    font-weight: 600;
  }

  .dialog-footer {
    text-align: right;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
  }
</style>
